import React, { useMemo, useRef } from 'react';
import { Box, Paper, Typography, Stack, Skeleton } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { getOgdOverview } from '../../../../redux/features/poinTrackerSlice';
import { useSelector } from 'react-redux';

const OGDOverview = ({ fromDate, toDate, selectedTeam }) => {
  const dispatch = useDispatch();
  const ogdOverview = useSelector((state) => state.pointTracker.ogdOverview);
  const { loading, responseData } = ogdOverview;
  const cardsOverview = responseData?.data || {};
  const dispatchParams = useMemo(() => {
    return {
      fromDate,
      toDate,
      wingId: selectedTeam.id === -1 ? null : selectedTeam.id,
    };
  }, [fromDate, toDate, selectedTeam.id]);
  const previousDispatchParams = useRef(dispatchParams);
  const isApiNeeded = JSON.stringify(previousDispatchParams.current) !== JSON.stringify(dispatchParams);

  useEffect(() => {
    if (Object.entries(ogdOverview?.responseData || {}).length === 0 || isApiNeeded) {
      dispatch(getOgdOverview(dispatchParams));
      previousDispatchParams.current = dispatchParams;
    }
  }, [dispatch, dispatchParams, ogdOverview?.responseData, isApiNeeded]);


  const formatCurrency = (value) => `₹${value?.toFixed(2)?.toLocaleString('en-IN')}`;

  const cards = [
    {
      title: 'TOTAL ADMISSIONS',
      value: cardsOverview?.totalAdmissions,
      sub: `vs last month: ${cardsOverview?.totalAdmissionLastMonth || 0}`,
      percent: cardsOverview?.trends?.admissions || 0,
      color: '#2563EB', // Blue
      bg: '#EFF6FF',
    },
    {
      title: 'GROSS SALES',
      value: formatCurrency(cardsOverview?.grossSales || 0),
      percent: cardsOverview?.trends?.grossSales || 0,
      color: '#9333EA', // Violet
      bg: '#F5F3FF',
    },
    {
      title: 'NET REVENUE',
      value: formatCurrency(cardsOverview?.totalRevenue || 0),
      percent: cardsOverview?.trends?.totalRevenue || 0,
      color: '#db7e27ff', // Pink
      bg: '#fdf8f0ff',
    },
    {
      title: 'ARPU',
      value: formatCurrency(cardsOverview?.arpu || 0),
      color: '#08a9b2ff', // Cyan
      bg: '#f0fdf4ff',
    },
    {
      title: 'ADS',
      value: formatCurrency(cardsOverview?.ads || 0),
      color: '#a31680ff', // Green
      bg: '#fdf0f9ff',
    },
  ];

  return (
    <Box>
      <Typography fontWeight={600} mb={2}>
        OGD Overview
      </Typography>

      {/* Horizontal Scroll Container */}
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          overflowX: 'auto',
          pb: 1,
          scrollBehavior: 'smooth',

          /* optional nice scrollbar */
          '&::-webkit-scrollbar': {
            height: 6,
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#c1c1c1',
            borderRadius: 3,
          },
        }}
      >
        {loading ? (
          Array.from({ length: 5 }).map((_, index) => (
            <Skeleton key={index} variant="rectangular" sx={{borderRadius:1,width:'223px',height:'118px'}}/>
          ))
        ) : (
          cards.map((card, index) => (
            <Paper
            key={index}
            sx={{
              minWidth: 220, // keeps card size fixed
              flexShrink: 0, // prevents shrinking
              p: 2,
              borderRadius: 1,
              border: `1px solid ${card.color}`,
              backgroundColor: card.bg,
            }}
          >
            <Typography variant="caption" color="text.secondary" fontWeight={600}>
              {card.title}
            </Typography>

            <Stack direction="row" alignItems="center" justifyContent="space-between" mt={1}>
              <Typography variant="h5" fontWeight={700} color={card.color}>
                {card.value}
              </Typography>

              {card.percent !==null && card.percent !==undefined && (
                <Stack
                  direction="row"
                  alignItems="center"
                  spacing={0.5}
                  sx={{
                    background: card.percent > 0 ? '#E8F5E9' : '#FFEBEE',
                    px: 1,
                    py: 0.3,
                    borderRadius: 2,
                  }}
                >
                  {card.percent > 0 ? (
                    <TrendingUpIcon sx={{ fontSize: 16, color: '#2e7d32' }} />
                  ) : (
                    <TrendingDownIcon sx={{ fontSize: 16, color: '#dc004e' }} />
                  )}
                  <Typography variant="caption" fontWeight={600} color={card.percent > 0 ? '#2e7d32' : '#dc004e'}>
                    {card.percent + '%'}
                  </Typography>
                </Stack>
              )}
            </Stack>
{/* 
            {card.sub && (
              <Typography variant="caption" color="text.secondary" mt={1} display="block">
                {card.sub}
              </Typography>
            )} */}
          </Paper>
        )))}
      </Box>
    </Box>
  );
};

export default OGDOverview;
